import { ApolloError } from '@apollo/client';
import { useGetJobsiteWorkerQuery } from 'apollo/generated/client-operations';
import {
  JobsiteWorkerOnboardingData,
  UseJobsiteWorkerOnboardingDataArgs,
} from 'containers/workerOnboarding/types';
import { useJobsiteWorkerOnboardingDocuments } from './useJobsiteWorkerOnboardingDocuments';

export function useJobsiteWorkerOnboardingData(
  args: UseJobsiteWorkerOnboardingDataArgs,
): JobsiteWorkerOnboardingData {
  const { jobsiteWorkerId } = args;

  const {
    data: jobsiteWorkerData,
    error: jobsiteWorkerError,
    loading: jobsiteWorkerLoading,
    refetch: refetchJobsiteWorker,
  } = useGetJobsiteWorkerQuery({
    variables: {
      jobsiteWorkerId,
    },
    fetchPolicy: 'no-cache',
  });

  const jobsiteWorker = jobsiteWorkerData?.getJobsiteWorker;

  const {
    jobsiteWorkerDocumentTypes,
    jobsiteWorkerDocuments,
    filteredDocumentTypeIds,
    refetchJobsiteWorkerDocuments,
    error: documentsError,
    loading: documentsLoading,
  } = useJobsiteWorkerOnboardingDocuments({ jobsiteWorker });

  const loading: boolean = jobsiteWorkerLoading || documentsLoading;
  const error: ApolloError = jobsiteWorkerError || documentsError;

  return {
    loading,
    error,
    jobsiteWorker,
    jobsiteWorkerDocumentTypes,
    jobsiteWorkerDocuments,
    filteredDocumentTypeIds,
    refetchJobsiteWorker,
    refetchJobsiteWorkerDocuments,
  };
}
